import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("sp_token", data.access_token);
    setUser(data);
    return data;
  }, []);

  const loginResponsabile = useCallback(async (username, password) => {
    const { data } = await api.post("/auth/login-responsabile", { username, password });
    if (data.access_token) localStorage.setItem("sp_token", data.access_token);
    setUser(data);
    return data;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    if (data.access_token) localStorage.setItem("sp_token", data.access_token);
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("sp_token");
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, login, loginResponsabile, register, logout }), [user, login, loginResponsabile, register, logout]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
